<template>
  <v-layout column>
    <h2>Service Tickets</h2>
    <v-flex d-inline-flex align-top>
      <v-flex class="max-min-width-title">
        <p>
          Listado de Service Tickets del mes de:
          <br />
          <span>
            <b>{{ currentMonth }}</b>
          </span>
        </p>
      </v-flex>
      <!-- NEXT MONTH -->
      <v-flex v-if="currentMonthNumber !== currentRealMonthNumber" pl-3>
        <v-btn
          class="text-capitalize"
          color="#6E8F82"
          large
          :dark="true"
          @click="loadNextMonth"
        >
          <font-awesome-icon
            class="mr-2"
            :style="{ color: '#FFFFFF' }"
            size="lg"
            :icon="['fal', 'cloud-download']"
          />
          Cargar {{ currentRealMonth }}
        </v-btn>
      </v-flex>
      <!-- BACK TO ST MONTH -->
      <v-flex v-else pl-3>
        <v-btn
          class="text-capitalize"
          color="#6E8F82"
          large
          :dark="true"
          @click="loadSTMonth"
        >
          <font-awesome-icon
            class="mr-2"
            :style="{ color: '#FFFFFF' }"
            size="lg"
            :icon="['fal', 'cloud-download']"
          />
          Cargar {{ currentSTMonth }}
        </v-btn>
      </v-flex>
    </v-flex>
    <!-- BAR -->
    <v-layout class="bar-style max-min-width" mb-3 px-3 pt-2>
      <v-flex>
        Service Tickets:
        <b>{{ currentServiceTickets.length }}</b>
      </v-flex>
      <v-flex>
        En Revisión:
        <b>
          {{ currentServiceTickets.filter(item => item.approved === 0).length }}
        </b>
      </v-flex>
      <v-flex>
        Aprobados:
        <b>
          {{ currentServiceTickets.filter(item => item.approved === 1).length }}
        </b>
      </v-flex>
      <v-flex>
        No Aprobados:
        <b>
          {{ currentServiceTickets.filter(item => item.approved === 2).length }}
        </b>
      </v-flex>
    </v-layout>
    <!-- DATA TABLE -->
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
          clearable
          color="#C46D24"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="currentServiceTickets"
        :search="search"
        class="elevation-1"
        rows-per-page-text="Cantidad de filas por página:"
        no-data-text="No se encontraron Datos relacionados."
        no-results-text="No se encontraron Resultados relacionados."
        :rows-per-page-items="[5, 10, 25, { text: 'Todas', value: -1 }]"
      >
        <template v-slot:items="props">
          <td>{{ props.item.user }}</td>
          <td>{{ roleMap.get(props.item.role) }}</td>
          <td>{{ props.item.emailLF }}</td>
          <td>{{ props.item.emailAODS }}</td>
          <td class="text-xs-center">
            <v-flex>
              <v-flex>
                {{ statusSTMap.get(props.item.approved) }}
              </v-flex>
              <v-flex v-if="props.item.approved === 1" pl-2>
                <v-btn
                  class="text-capitalize"
                  color="#466EA5"
                  small
                  dark
                  :href="
                    `https://us-central1-${projectId}.cloudfunctions.net/app/getFormatPdf?id=${
                      props.item.key
                    }`
                  "
                >
                  <font-awesome-icon
                    class="mr-2"
                    :style="{ color: '#FFFFFF' }"
                    size="lg"
                    :icon="['fal', 'file-download']"
                  />
                  PDF
                </v-btn>
              </v-flex>
            </v-flex>
          </td>
          <td class="text-xs-center">{{ props.item.ods }}</td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Su busqueda: "{{ search }}" no se encontró.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

const projectId = process.env.VUE_APP_PROJECT_ID;

const statusSTMap = new Map([
  [0, "En Revisión"],
  [1, "Aprobado"],
  [2, "No Aprobado"]
]);

const roleMap = new Map([
  [0, "Operativo"],
  [1, "Administrativo"],
  [2, "Lider Funcional"],
  [3, "Administrador ODS"]
]);

export default {
  name: "ServiceTickets",
  data() {
    return {
      projectId,
      search: "",
      headers: [
        { text: "Email", align: "left", value: "user" },
        { text: "Rol", align: "left", value: "role" },
        { text: "Lider Funcional", align: "left", value: "emailLF" },
        { text: "Administrador ODS", align: "left", value: "emailAODS" },
        { text: "Estado ST", align: "center", value: "approved" },
        { text: "ODS", align: "center", value: "ods" }
      ],
      statusSTMap,
      roleMap
    };
  },
  computed: {
    ...mapGetters([
      "currentSTMonth",
      "currentRealMonth",
      "currentRealMonthNumber",
      "currentMonthNumber",
      "currentServiceTickets",
      "currentMonth"
    ])
  },
  methods: {
    ...mapActions(["fetchCurrentServiceTickets"]),
    loadSTMonth() {
      console.log("loadSTMonth");
      this.$store.commit("CHANGE_CURRENT_REAL_MONTH");
      this.fetchCurrentServiceTickets();
    },
    loadNextMonth() {
      console.log("loadNextMonth");
      this.$store.commit("CHANGE_CURRENT_MONTH");
      this.fetchCurrentServiceTickets();
    }
  },
  created() {
    this.fetchCurrentServiceTickets();
  }
};
</script>

<style lang="stylus" scoped>
span
  font-size 24px
  color #212121

.max-min-width-title
  max-width 250px
  min-width 250px

.max-min-width
  max-width 1024px
  min-width 1024px

.bar-style
  background-color #C46D24
  border-radius 8px
  height 50px
  font-size 21px
  color white
</style>
